import { render, staticRenderFns } from "./DashboardHeadHuntedItem.vue?vue&type=template&id=93a20e2c"
import script from "./DashboardHeadHuntedItem.vue?vue&type=script&lang=js"
export * from "./DashboardHeadHuntedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports